var exports = {
  "UD": "ApplicationsTab.module__buttonContainer___elgzNF",
  "qI": "ApplicationsTab.module__listContainer___elgzNF",
  "DB": "ApplicationsTab.module__itemContainer___elgzNF",
  "k0": "ApplicationsTab.module__itemButton___elgzNF",
  "HS": "ApplicationsTab.module__itemLeft___elgzNF",
  "vi": "ApplicationsTab.module__itemAvatar___elgzNF",
  "KO": "ApplicationsTab.module__itemAvatarPlaceholder___elgzNF",
  "c2": "ApplicationsTab.module__itemTextBlock___elgzNF",
  "wH": "ApplicationsTab.module__itemTitleRow___elgzNF",
  "TJ": "ApplicationsTab.module__itemName___elgzNF",
  "Fg": "ApplicationsTab.module__itemMetaRow___elgzNF",
  "v5": "ApplicationsTab.module__itemChevron___elgzNF",
  "p$": "ApplicationsTab.module__emptyState___elgzNF",
  "dc": "ApplicationsTab.module__spinnerContainer___elgzNF",
};

module.exports = exports;
